import { Divider, Flex } from '@mantine/core';
import { ChatState, Message, MessageDirection } from '../chat/types';
import { PresentedFileCard } from './PresentedFileCard';
import { SiestaMessage } from './SiestaMessage';
import { ToolLimitReachedWidget } from './ToolLimitReachedWidget';
import { UserMessage } from './UserMessage';

type Props = {
  messages: Message[];
  latestIncomingId?: string;
  isStreaming?: boolean;
  onContinue: (widgetMessageId: string) => void;
};

export function SiestaBarMessages({ messages, latestIncomingId, isStreaming, onContinue }: Props) {
  return (
    <Flex direction="column" gap="md" px="md" py="md">
      {messages.map(message => {
        if (message.kind === 'interrupted') {
          return (
            <Divider
              key={message.id}
              label="Interrupted"
              labelPosition="center"
              c="dimmed"
              my="xs"
            />
          );
        }
        if (message.direction === MessageDirection.Outgoing) {
          return (
            <UserMessage
              key={message.id}
              content={message.answerContent || message.response[0]?.content || ''}
            />
          );
        }

        if (message.currentState === ChatState.TOOL_LIMIT_REACHED) {
          const hasPrePauseContent = Boolean(
            message.answerContent.trim() || message.thinkingContent.trim(),
          );
          return (
            <Flex key={message.id} direction="column" gap="md">
              {hasPrePauseContent && (
                <SiestaMessage
                  content={message.answerContent}
                  thinkingContent={message.thinkingContent}
                />
              )}
              {message.presentedFiles?.map(file => (
                <PresentedFileCard key={file.url} file={file} />
              ))}
              <ToolLimitReachedWidget
                onContinue={() => onContinue(message.id)}
                disabled={isStreaming}
              />
            </Flex>
          );
        }

        const isLatest = message.id === latestIncomingId;
        const isToolInFlight = Boolean(message.currentToolName);
        const isThinking =
          isLatest &&
          isStreaming &&
          (isToolInFlight ||
            (message.currentState !== 'ANSWERING' &&
              message.currentState !== 'SENT' &&
              message.currentState !== ''));

        return (
          <Flex key={message.id} direction="column" gap="md">
            <SiestaMessage
              content={message.answerContent}
              thinkingContent={message.thinkingContent}
              isThinking={isThinking}
              currentState={message.currentState}
              currentToolName={isThinking ? message.currentToolName : undefined}
            />
            {message.presentedFiles?.map(file => (
              <PresentedFileCard key={file.url} file={file} />
            ))}
          </Flex>
        );
      })}
    </Flex>
  );
}
